import { getLocale } from "../runtime";

const sv_usecases = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Användningsområden`
};

const usecases = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_usecases(inputs)
	return "useCases";
};

export { usecases as "useCases" };